import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

interface LanguageWrapperProps {
  toggleEnvironment: () => void;
}

/**
 * Calls toggleEnvironment when the language route unmounts,
 * replacing the v3 onLeave hook behavior.
 */
function RouteLeaveHandler({ toggleEnvironment }: { toggleEnvironment: () => void }) {
  useEffect(() => {
    return () => {
      toggleEnvironment();
    };
  }, [toggleEnvironment]);

  return null;
}

const LanguageWrapper: React.FC<LanguageWrapperProps> = ({ toggleEnvironment }) => {
  return (
    <div>
      <RouteLeaveHandler toggleEnvironment={toggleEnvironment} />
      <Outlet />
    </div>
  );
};

export { RouteLeaveHandler };
export { LanguageWrapper as default };
